export default {"src":"/_next/static/media/pointed-arrow-right.4b545eb3.svg","height":14,"width":18};